import "./index.css";

const GradientOrb = () => {
  return (
    <div className="gradientOrb__wrapper">
      <div className="gradientOrb"></div>
    </div>
  );
};
export default GradientOrb;
